import { useParams, Navigate } from "react-router-dom";

const UPDATED = "June 2026";

const PAGES = {
  privacy: {
    title: "Privacy Policy",
    intro:
      "At LIRA, your privacy matters to us. This policy explains what information we collect, how we use it, and the choices you have.",
    sections: [
      {
        h: "Information We Collect",
        p: "When you shop with us, create an account, or subscribe to our email or text updates, we collect information you provide such as your name, email address, phone number, shipping address, and order details. Payment information is processed securely by PayPal — we never store your full card details on our servers.",
      },
      {
        h: "How We Use Your Information",
        p: "We use your information to process and ship your orders, provide customer support, send order and shipping confirmations, and — with your consent — send marketing emails and text messages about new arrivals, restocks, and private sales.",
      },
      {
        h: "Email & SMS Marketing",
        p: "You can opt into our newsletter and text-message list at any time. Every marketing email includes an Unsubscribe link, and you can reply STOP to any text message to opt out of SMS. We will honour these requests promptly.",
      },
      {
        h: "Sharing Your Information",
        p: "We share information only with trusted service providers who help us operate our store — such as PayPal (payments), our shipping carriers, and our email/SMS providers. We never sell your personal information.",
      },
      {
        h: "Data Security",
        p: "We take reasonable measures to protect your information. All transactions are encrypted, and access to personal data is restricted to authorised personnel.",
      },
      {
        h: "Contact Us",
        p: "For any privacy questions or to request access to or deletion of your data, email us at lirascarves@gmail.com.",
      },
    ],
  },
  terms: {
    title: "Terms of Service",
    intro:
      "These Terms govern your use of the LIRA website and your purchases from us. By using our site or placing an order, you agree to these Terms.",
    sections: [
      {
        h: "Products & Pricing",
        p: "All prices are listed in Canadian Dollars (CAD). We strive for accuracy in product descriptions, colours, and pricing, but slight variations in colour may occur due to screen settings. We reserve the right to correct errors and update prices at any time.",
      },
      {
        h: "Orders & Payment",
        p: "Placing an order constitutes an offer to purchase. Payment is processed securely through PayPal at checkout. We reserve the right to refuse or cancel any order, including in cases of suspected fraud or pricing errors.",
      },
      {
        h: "Shipping & Taxes",
        p: "Orders ship from Ontario, Canada. Applicable Canadian sales tax is calculated at checkout. For international orders, any customs duties, taxes, and import fees are the responsibility of the customer.",
      },
      {
        h: "Intellectual Property",
        p: "All content on this site — including the LIRA name, logo, imagery, and text — is the property of LIRA and may not be reproduced without written permission.",
      },
      {
        h: "Limitation of Liability",
        p: "LIRA is not liable for any indirect or incidental damages arising from the use of our products or website, to the fullest extent permitted by law.",
      },
      {
        h: "Contact Us",
        p: "Questions about these Terms? Reach us at lirascarves@gmail.com.",
      },
    ],
  },
  "refund-policy": {
    title: "Returns & Exchanges",
    intro:
      "Returns & Exchanges will not be accepted. If you require help with a product you received, please contact us by email: support@lirascarves.com.",
    sections: [
      {
        h: "All Sales Are Final",
        p: "We do not accept returns or exchanges on any items. Please review your order carefully — including size, colour, and quantity — before completing your purchase.",
      },
      {
        h: "Need Help With Your Order?",
        p: "If there is an issue with a product you received, we're here to help. Please email us at support@lirascarves.com with your order number and a description of the problem, and our team will get back to you.",
      },
    ],
  },
};

export default function LegalPage() {
  const { slug } = useParams();
  const page = PAGES[slug];
  if (!page) return <Navigate to="/" replace />;

  return (
    <div className="container-lira py-16 md:py-24 max-w-3xl" data-testid={`legal-page-${slug}`}>
      <p className="eyebrow mb-3">Legal</p>
      <h1 className="font-serif text-4xl md:text-5xl font-light tracking-tight mb-3" data-testid="legal-title">
        {page.title}
      </h1>
      <p className="text-xs uppercase tracking-[0.2em] text-[#737373] mb-8">Last updated: {UPDATED}</p>
      <p className="text-base text-[#5a5a5a] leading-relaxed mb-12">{page.intro}</p>
      <div className="space-y-10">
        {page.sections.map((s) => (
          <section key={s.h}>
            <h2 className="font-serif text-xl md:text-2xl text-[#1A1A1A] mb-3">{s.h}</h2>
            <p className="text-base text-[#5a5a5a] leading-relaxed">{s.p}</p>
          </section>
        ))}
      </div>
    </div>
  );
}
